export const FORMATOS = [
  { valor: 'pdf', etiqueta: 'PDF', ayuda: 'Para imprimir y archivar' },
  {
    valor: 'xlsx',
    etiqueta: 'Excel',
    ayuda: 'Reproduce el PDF: sirve para mirar, no para filtrar',
  },
] as const;
